import React, { FC } from 'react'
import { getReadableTimeSince } from '../../../../__helpers/get-readable-time-since'
import {
    StyledPublicationDate,
    StyledPublicationDateWrapper,
} from './PublishedTime.styled'

interface NightlyPublishedTimeProps {
    shouldDisplay?: boolean
    publicationDate?: string
}

export const PublishedTime: FC<NightlyPublishedTimeProps> = ({
    shouldDisplay = true,
    publicationDate,
}) => {
    if (!shouldDisplay || !publicationDate) return null

    const publicationDateMessage = getReadableTimeSince(
        publicationDate,
        new Date().toISOString(),
    )

    return (
        <StyledPublicationDateWrapper>
            <StyledPublicationDate dateTime={publicationDate}>
                {publicationDateMessage}
            </StyledPublicationDate>
        </StyledPublicationDateWrapper>
    )
}
